module.exports = "<p>\n  client-clustering works!\n</p>\n"